/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AutomapOptions } from "./AutomapOptions";
export const AutomapTemplateOptions = core.serialization.object({
    namespace: core.serialization.string().optional(),
    options: AutomapOptions,
});
